@if (consent.initialized() && consent.analytics() === 'undecided') {
  <section class="consent-banner" aria-labelledby="consent-title">
    <div class="consent-copy">
      <h2 id="consent-title">Analítica opcional</h2>
      <p>
        Nos ayuda a saber qué contenidos resultan útiles. Solo se activa si la aceptas y nunca
        incluye los datos del formulario.
        <a routerLink="/cookies">
          Más información<span class="visually-hidden">
            sobre cookies y analítica opcional</span
          > </a
        >.
      </p>
    </div>
    <div class="consent-actions">
      <button type="button" class="button-secondary" (click)="consent.choose('denied')">
        Rechazar analítica
      </button>
      <button type="button" (click)="consent.choose('granted')">Aceptar analítica</button>
    </div>
  </section>
}

<dialog #settingsDialog aria-labelledby="settings-title" (close)="closeFromDialog()">
  <div class="dialog-content">
    <h2 id="settings-title">Configurar analítica</h2>
    <p>
      Las tecnologías necesarias mantienen la web y el formulario operativos. Google Analytics es
      opcional y solo se utiliza con tu autorización.
    </p>
    <p class="current-choice">
      <strong>Preferencia actual:</strong>
      @switch (consent.analytics()) {
        @case ('granted') {
          analítica aceptada.
        }
        @case ('denied') {
          analítica rechazada.
        }
        @default {
          todavía no has elegido.
        }
      }
    </p>
    <div class="consent-actions">
      <button type="button" class="button-secondary" (click)="consent.choose('denied')">
        Rechazar analítica
      </button>
      <button type="button" (click)="consent.choose('granted')">Aceptar analítica</button>
    </div>
    <button type="button" class="close-button" (click)="consent.closeSettings()">Cerrar</button>
  </div>
</dialog>
